<script lang="ts" setup>
import MCard from "../MCard";
import MList, { MListItem } from "./";
import MBadge from "../MBadge";
</script>
<template>
  <div class="flex flex-col gap-3">
    <m-list>
      <m-list-item>
        <p>Some text</p>
      </m-list-item>

      <m-list-item @click="() => {}">
        <p>With click</p>
      </m-list-item>

      <m-list-item icon-name="fa-light fa-xmark" @click="() => {}">
        <p>With icon xmark</p>
      </m-list-item>

      <m-list-item to-slideover="something">
        <p>With toSlideover</p>
      </m-list-item>
      <m-list-item to-modal="something">
        <p>With toModal</p>
      </m-list-item>

      <m-list-item presentation-style="vertical-line">
        <p>VerticalLine Some text</p>
      </m-list-item>

      <m-list-item presentation-style="vertical-line" @click="() => {}">
        <p>VerticalLine With click</p>
      </m-list-item>

      <m-list-item to-slideover="something" presentation-style="vertical-line">
        <p>VerticalLine With toSlideover</p>
      </m-list-item>
      <m-list-item to-modal="something" presentation-style="vertical-line">
        <p>VerticalLine With toModal</p>
      </m-list-item>

      <m-list-item class="hover-component" to="#">
        <p>Hover</p>
      </m-list-item>

      <m-list-item
        >Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.>Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.Withlongtext.
      </m-list-item>
    </m-list>

    <m-card title="With MCard" :action="{ label: 'Action' }">
      <m-list>
        <m-list-item>
          <p>Some text</p>
        </m-list-item>

        <m-list-item @click="() => {}">
          <p>With click</p>
        </m-list-item>

        <m-list-item icon-name="fa-light fa-xmark" @click="() => {}">
          <p>With icon xmark</p>
        </m-list-item>

        <m-list-item to-slideover="something">
          <p>With toSlideover</p>
        </m-list-item>
        <m-list-item to-modal="something">
          <p>With toModal</p>
        </m-list-item>

        <m-list-item presentation-style="vertical-line">
          <p>VerticalLine Some text</p>
        </m-list-item>

        <m-list-item presentation-style="vertical-line" @click="() => {}">
          <p>VerticalLine With click</p>
        </m-list-item>

        <m-list-item to-slideover="something" presentation-style="vertical-line">
          <p>VerticalLine With toSlideover</p>
        </m-list-item>
        <m-list-item to-modal="something" presentation-style="vertical-line">
          <p>VerticalLine With toModal</p>
        </m-list-item>

        <m-list-item presentation-style="vertical-line">
          <p>VerticalLine with:</p>
          <p class="empty-text">other child</p>
          <m-badge>Items</m-badge>
        </m-list-item>

        <m-list-item class="hover-component" to="#">
          <p>Hover</p>
        </m-list-item>
      </m-list>
    </m-card>
    <span />
  </div>
</template>
